import { render, staticRenderFns } from "./IngredientsCalculator.vue?vue&type=template&id=2d3d3459&scoped=true&"
import script from "./IngredientsCalculator.vue?vue&type=script&lang=js&"
export * from "./IngredientsCalculator.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsCalculator.vue?vue&type=style&index=0&id=2d3d3459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d3459",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDivider,VExpandTransition,VForm,VSlider,VTextField})
